
import '../CountryDetails.scss';

const CountryFlag = ({ countryCode }: { countryCode :string}) => {


    return countryCode ? <div
        className="flag"
        style={{
            backgroundImage: `url(https://flagcdn.com/${countryCode}.svg)`,
        }}
    />:null
};

export default CountryFlag;
